import { Checkbox, CheckboxProps, FormControlLabel, FormControlLabelProps } from '@mui/material';
import { Control, Controller, FieldPath, FieldValues, RegisterOptions } from 'react-hook-form';

type OwnProps<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>> = {
    name: TName;
    control: Control<TFieldValues>;
    rules?: Omit<RegisterOptions<TFieldValues, TName>, 'valueAsNumber' | 'valueAsDate' | 'setValueAs'>;
    label: string;
    labelProps?: Omit<FormControlLabelProps, 'label'>;
} & CheckboxProps;

export function FormCheckbox<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>({
    name,
    control,
    rules,
    label,
    labelProps,
    disabled,
    ...props
}: OwnProps<TFieldValues, TName>) {
    const formControlLabelProps = labelProps ?? {};

    return (
        <FormControlLabel
            control={
                <Controller
                    name={name}
                    control={control}
                    rules={rules}
                    render={({ field: { value, onChange, ...rest } }) => (
                        <Checkbox
                            checked={!!value}
                            onChange={e => onChange(e.target.checked)}
                            disabled={disabled}
                            {...rest}
                            {...props}
                        />
                    )}
                />
            }
            label={label}
            disabled={disabled}
            {...formControlLabelProps}
        />
    );
}
